<template>
  <div class="work-item text-center">
    <a-row type="flex">
      <a-col :span="24">
        <a-avatar class="work-icon" shape="square" size="large" @click="showModal()">
            <a-icon type="plus" />
        </a-avatar>
      </a-col>
    </a-row>
    <a-row type="flex">
      <a-col :span="24">
          <p class="work-label">Ajouter</p>
      </a-col>
    </a-row>
    <a-modal
      :class="{ 'dark-theme-modal': darkTheme }"
      title="Ajouter un travail"
      v-model="modalVisible"
      okText="Ajouter"
      :okButtonProps="darkTheme ? { props: {ghost: true} } : null"
      cancelText="Annuler"
      :cancelButtonProps="darkTheme ? { props: {ghost: true} } : null"
      @ok="handleCreate"
      @cancel="handleCancel">
      <a-row type="flex">
        <a-col :span="6"></a-col>
        <a-col :span="12">
          <a-form :form="form">
            <a-form-item label="Titre :">
              <a-auto-complete
                autoFocus
                class="add-work-title-input"
                :class="{ 'dark-theme-select': darkTheme }"
                :dataSource="dataPortfolio"
                size="large"
                placeholder="Entrez un titre"
                :filterOption="filterOption"
                v-decorator="[
                  'titreTravail',
                  {
                    rules: [{ required: true, message: 'Veuillez entrer un titre' },
                    {
                      pattern: '.*[^0-9 ].*',
                      message: 'Ne dois pas contenir uniquement des chiffres'
                    }, {
                      pattern: '.*[^ ].*',
                      message: 'Ne dois pas être vide'
                    }, {
                      pattern: '^.{1,40}$',
                      message: 'Ne dois pas contenir plus de 40 caractères'
                    }]
                  }
                ]"
              />
            </a-form-item>
            <a-form-item label="Date de création :">
              <a-date-picker
                class="add-work-date-input"
                :class="{ 'dark-theme-calendar': darkTheme }"
                size="large"
                placeholder="Entrez une date"
                v-decorator="[
                  'dateCreation',
                  {
                    rules: [{ required: true, message: 'Veuillez entrer une date' }],
                    initialValue: moment()
                  }
                ]"
                :format="dateFormat" />
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="6"></a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import WorkService from '../../services/work_service'
import DateService from '../../services/date_service'
import PortfolioService from '../../services/portfolio_service'

export default {
  name: 'AddWorkItem',
  data () {
    return {
      modalVisible: false,
      dateFormat: 'DD.MM.YYYY',
      form: this.$form.createForm(this),
      dataPortfolio: []
    }
  },
  methods: {
    moment,
    ...mapActions({
      'addWork': 'work/addWork',
      'sortWorksNonChronological': 'work/sortWorksNonChronological'
    }),
    showModal () {
      this.modalVisible = true
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleCreate (e) {
      this.form.validateFields(async (err, values) => {
        if (err) {
          return
        }
        // Préparation des paramètres pour la requête
        let params = {
          titreTravail: values.titreTravail,
          dateCreation: DateService.formatDateToDatabaseFormat(values.dateCreation),
          heureCreation: moment().format('HH:mm')
        }
        // ID portfolio
        const index = this.dataPortfolio.indexOf(values.titreTravail)
        if (index !== -1) {
          params.idPortfolio = index
        }
        // Login par défaut
        let login = this.user.login
        // Si l'utilisateur est enseignant, on ne créera pas le travail au nom de l'enseignant
        if (this.user.permissionLevel === 1) {
          // Récupération du login de l'utilisateur sélectionné
          const element = this.studentsDataMapLogin.find((element) => element.fullname === this.defaultStudent)
          login = element.login
        }
        login = login.toLowerCase()
        // Requête
        const response = await WorkService.createWork(login, params)
        if (response) {
          const data = DateService.formatObjectArrayDatesToDisplayFormat([response.data.data], 'display')
          this.addWork(data[0])
          // Trier par ordre chronologique décroissant
          this.sortWorksNonChronological()
          this.form.resetFields()
          this.modalVisible = false
          this.$message.success('Travail créé')
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
    },
    normalizeName (name) {
      name = name.toLowerCase()
      // Enlever les accents
      name = name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      // Enlever les quotes
      name = name.replace(/['']+/g, '')
      return name
    }
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      user: state => state.auth.user,
      worksData: state => state.work.worksData,
      studentsData: state => state.ldap.studentsData,
      studentsDataMapLogin: state => state.ldap.studentsDataMapLogin,
      defaultStudent: state => state.ldap.defaultStudent
    })
  },
  async created () {
    // fetch API portfolio
    if (this.user.permissionLevel === 0) {
      console.log('fetch portfolio')
      // Préparation de l'email
      const fullname = this.user.fullname
      let name = fullname.substr(0, fullname.indexOf(' '))
      name = this.normalizeName(name)
      let lastname = fullname.substr(fullname.indexOf(' ') + 1)
      // Enlever les espaces
      lastname = lastname.replace(/\s/g, '')
      lastname = this.normalizeName(lastname)
      let email = `${name}.${lastname}@rpn.ch`
      const response = await PortfolioService.getOpenTasks(email)
      if (response) {
        const data = response.data.data
        if (data) {
          Object.keys(data).forEach((key) => {
            this.dataPortfolio[key] = data[key].name
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.work-item{
    margin-top: 10px;
}
.work-icon{
    border: 1.5px dashed gray;
    border-radius: 20px;
    background-color: transparent;
    width: 130px;
    height: 130px;
    font-size: 3em;
    color: gray;
    cursor: pointer;
}
.work-icon:hover{
    border: 2.5px solid #40a9ff;
}
.work-label{
    color: gray;
    font-size: 1.5em;
}
// Modal
.add-work-date-input{
  width: 100%;
}
</style>
